module.exports = __webpack_public_path__ + "static/media/mrwork.c8dc0623.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/mrwork.webp
// module id = 318
// module chunks = 0